import { API } from 'config';

function PropertyService($resource) {

  'ngInject';

  const PropertyResource = $resource(API.CONFIG, { id: '@id' }, {
    get: {
      method: 'GET',
    },
    save: {
      method: 'POST',
    },
  });

  return {
    get: (id) => PropertyResource.get({ id }).$promise,
    save: (property) => PropertyResource.save(property).$promise,
  };

}

export default PropertyService;



// WEBPACK FOOTER //
// ./src/services/Property.js